module.exports = __webpack_public_path__ + "img/coupon.eea4e969.png";